import { Controller } from "stimulus"

export default class extends Controller {
  connect() {
    // After appendChild moves this element to body, Stimulus creates a NEW
    // controller instance for the re-connect. Use a DOM attribute (persists
    // across instances) to detect we've already initialized.
    if (this.element.dataset.modalReady) return

    this.element.dataset.modalReady = "true"
    document.body.appendChild(this.element)

    $(this.element).modal({ backdrop: true, keyboard: true })
    $(this.element).modal("show")

    $(this.element).on("hidden.bs.modal", () => {
      this._cleanupModal()
      // Clear content but keep the turbo frame shell so it can be
      // targeted again by the next Schedule button click
      const modalContent = this.element.querySelector('#modal_content, turbo-frame#modal_content')
      if (modalContent) modalContent.innerHTML = ''
      this.element.dataset.modalReady = ""
    })
  }

  disconnect() {
    // If element is on body, this is the intermediate disconnect from the
    // appendChild move — not a real teardown. Skip cleanup.
    if (this.element.parentElement === document.body) return

    $(this.element).modal("hide")
    this._cleanupModal()
  }

  closeModal(event) {
    event.preventDefault()
    $(this.element).modal("hide")
  }

  _cleanupModal() {
    document.querySelectorAll(".modal-backdrop").forEach(el => el.remove())
    document.body.classList.remove("modal-open")
    document.body.style.overflow = ""
    document.body.style.paddingRight = ""
  }
}
